export const targetTextPositionPreset1bLandscape = {
    'bottom_right': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 1,
                },
                'position': {
                    'x': 1820,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_center': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 1,
                },
                'position': {
                    'x': 960,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'top_left': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'position': {
                    'x': 120,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center_left': [
        {
            'maxHeight': 800,
            'maxWidth': 820,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0.5,
                },
                'position': {
                    'x': 120,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'center_right': [
        {
            'maxHeight': 800,
            'maxWidth': 820,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0.5,
                },
                'position': {
                    'x': 1820,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'top_right': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0,
                },
                'position': {
                    'x': 1820,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center': [
        {
            'maxHeight': 500,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0.5,
                },
                'position': {
                    'x': 960,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_left': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 1,
                },
                'position': {
                    'x': 120,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'top_center': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0,
                },
                'position': {
                    'x': 960,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
};
export const targetTextPositionPreset1bSquare = {
    'bottom_right': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 1,
                },
                'position': {
                    'x': 1023.75,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_center': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 1,
                },
                'position': {
                    'x': 540,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'top_left': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'position': {
                    'x': 67.5,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center_left': [
        {
            'maxHeight': 800,
            'maxWidth': 461.25,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0.5,
                },
                'position': {
                    'x': 67.5,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'center_right': [
        {
            'maxHeight': 800,
            'maxWidth': 461.25,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0.5,
                },
                'position': {
                    'x': 1023.75,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'top_right': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0,
                },
                'position': {
                    'x': 1023.75,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center': [
        {
            'maxHeight': 500,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0.5,
                },
                'position': {
                    'x': 540,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_left': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 1,
                },
                'position': {
                    'x': 67.5,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'top_center': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0,
                },
                'position': {
                    'x': 540,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
};
export const targetTextPositionPreset1bVertical = {
    'bottom_right': [
        {
            'maxHeight': 500,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 1,
                },
                'position': {
                    'x': 1023.75,
                    'y': 1742.2222222222222,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_center': [
        {
            'maxHeight': 500,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 1,
                },
                'position': {
                    'x': 540,
                    'y': 1742.2222222222222,
                },
                'rotation': 0,
            },
        },
    ],
    'top_left': [
        {
            'maxHeight': 500,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'position': {
                    'x': 67.5,
                    'y': 213.33333333333331,
                },
                'rotation': 0,
            },
        },
    ],
    'center_left': [
        {
            'maxHeight': 1422.2222222222222,
            'maxWidth': 600,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0.5,
                },
                'position': {
                    'x': 67.5,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'center_right': [
        {
            'maxHeight': 1422.2222222222222,
            'maxWidth': 600,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0.5,
                },
                'position': {
                    'x': 1023.75,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'top_right': [
        {
            'maxHeight': 500,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0,
                },
                'position': {
                    'x': 1023.75,
                    'y': 213.33333333333331,
                },
                'rotation': 0,
            },
        },
    ],
    'center': [
        {
            'maxHeight': 888.8888888888888,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0.5,
                },
                'position': {
                    'x': 540,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_left': [
        {
            'maxHeight': 500,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 1,
                },
                'position': {
                    'x': 67.5,
                    'y': 1742.2222222222222,
                },
                'rotation': 0,
            },
        },
    ],
    'top_center': [
        {
            'maxHeight': 888.8888888888888,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0,
                },
                'position': {
                    'x': 540,
                    'y': 213.33333333333331,
                },
                'rotation': 0,
            },
        },
    ],
};
export const targetTextPositionPreset2bLandscape = {
    'bottom_right': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 1,
                },
                'position': {
                    'x': 1820,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_center': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 1,
                },
                'position': {
                    'x': 960,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'top_left': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'position': {
                    'x': 120,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center_left': [
        {
            'maxHeight': 800,
            'maxWidth': 820,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0.5,
                },
                'position': {
                    'x': 120,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'center_right': [
        {
            'maxHeight': 800,
            'maxWidth': 820,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0.5,
                },
                'position': {
                    'x': 1820,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'top_right': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0,
                },
                'position': {
                    'x': 1820,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center': [
        {
            'maxHeight': 500,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0.5,
                },
                'position': {
                    'x': 960,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_left': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 1,
                },
                'position': {
                    'x': 120,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'top_center': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0,
                },
                'position': {
                    'x': 960,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
};
export const targetTextPositionPreset2bSquare = {
    'bottom_right': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 1,
                },
                'position': {
                    'x': 1023.75,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_center': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 1,
                },
                'position': {
                    'x': 540,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'top_left': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'position': {
                    'x': 67.5,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center_left': [
        {
            'maxHeight': 800,
            'maxWidth': 461.25,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0.5,
                },
                'position': {
                    'x': 67.5,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'center_right': [
        {
            'maxHeight': 800,
            'maxWidth': 461.25,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0.5,
                },
                'position': {
                    'x': 1023.75,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'top_right': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0,
                },
                'position': {
                    'x': 1023.75,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center': [
        {
            'maxHeight': 500,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0.5,
                },
                'position': {
                    'x': 540,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_left': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 1,
                },
                'position': {
                    'x': 67.5,
                    'y': 980,
                },
                'rotation': 0,
            },
        },
    ],
    'top_center': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0,
                },
                'position': {
                    'x': 540,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
};
export const targetTextPositionPreset2bVertical = {
    'bottom_right': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 1,
                },
                'position': {
                    'x': 1023.75,
                    'y': 1742.2222222222222,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_center': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 1,
                },
                'position': {
                    'x': 540,
                    'y': 1742.2222222222222,
                },
                'rotation': 0,
            },
        },
    ],
    'top_left': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'position': {
                    'x': 67.5,
                    'y': 213.33333333333331,
                },
                'rotation': 0,
            },
        },
    ],
    'center_left': [
        {
            'maxHeight': 1422.2222222222222,
            'maxWidth': 461.25,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0.5,
                },
                'position': {
                    'x': 67.5,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'center_right': [
        {
            'maxHeight': 1422.2222222222222,
            'maxWidth': 461.25,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0.5,
                },
                'position': {
                    'x': 1023.75,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'top_right': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0,
                },
                'position': {
                    'x': 1023.75,
                    'y': 213.33333333333331,
                },
                'rotation': 0,
            },
        },
    ],
    'center': [
        {
            'maxHeight': 888.8888888888888,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0.5,
                },
                'position': {
                    'x': 540,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_left': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 1,
                },
                'position': {
                    'x': 67.5,
                    'y': 1742.2222222222222,
                },
                'rotation': 0,
            },
        },
    ],
    'top_center': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0,
                },
                'position': {
                    'x': 540,
                    'y': 213.33333333333331,
                },
                'rotation': 0,
            },
        },
    ],
};
export const targetTextPositionPreset3bLandscape = {
    'bottom_right': [
        {
            'maxHeight': 450,
            'maxWidth': 1500,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 1,
                },
                'position': {
                    'x': 1820,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_center': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 1,
                },
                'position': {
                    'x': 960,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'top_left': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'position': {
                    'x': 120,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center_left': [
        {
            'maxHeight': 800,
            'maxWidth': 800,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0.5,
                },
                'position': {
                    'x': 120,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'center_right': [
        {
            'maxHeight': 800,
            'maxWidth': 800,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0.5,
                },
                'position': {
                    'x': 1860,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'top_right': [
        {
            'maxHeight': 450,
            'maxWidth': 1500,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0,
                },
                'position': {
                    'x': 1820,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center': [
        {
            'maxHeight': 500,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0.5,
                },
                'position': {
                    'x': 960,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_left': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 1,
                },
                'position': {
                    'x': 120,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'top_center': [
        {
            'maxHeight': 450,
            'maxWidth': 1550,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0,
                },
                'position': {
                    'x': 960,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
};

export const targetTextPositionPreset3bSquare = {
    'bottom_right': [
        {
            'maxHeight': 450,
            'maxWidth': 843.75,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 1,
                },
                'position': {
                    'x': 1023.75,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_center': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 1,
                },
                'position': {
                    'x': 540,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'top_left': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'position': {
                    'x': 67.5,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center_left': [
        {
            'maxHeight': 800,
            'maxWidth': 450,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0.5,
                },
                'position': {
                    'x': 67.5,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'center_right': [
        {
            'maxHeight': 800,
            'maxWidth': 450,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0.5,
                },
                'position': {
                    'x': 1046.25,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'top_right': [
        {
            'maxHeight': 450,
            'maxWidth': 843.75,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0,
                },
                'position': {
                    'x': 1023.75,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
    'center': [
        {
            'maxHeight': 500,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0.5,
                },
                'position': {
                    'x': 540,
                    'y': 540,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_left': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 1,
                },
                'position': {
                    'x': 67.5,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'top_center': [
        {
            'maxHeight': 450,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0,
                },
                'position': {
                    'x': 540,
                    'y': 120,
                },
                'rotation': 0,
            },
        },
    ],
};

export const targetTextPositionPreset3bVertical = {
    'bottom_right': [
        {
            'maxHeight': 800,
            'maxWidth': 843.75,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 1,
                },
                'position': {
                    'x': 1023.75,
                    'y': 1706.6666666666665,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_center': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 1,
                },
                'position': {
                    'x': 540,
                    'y': 1706.6666666666665,
                },
                'rotation': 0,
            },
        },
    ],
    'top_left': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0,
                },
                'position': {
                    'x': 67.5,
                    'y': 213.33333333333331,
                },
                'rotation': 0,
            },
        },
    ],
    'center_left': [
        {
            'maxHeight': 1422.2222222222222,
            'maxWidth': 450,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 0.5,
                },
                'position': {
                    'x': 67.5,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'center_right': [
        {
            'maxHeight': 1422.2222222222222,
            'maxWidth': 450,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0.5,
                },
                'position': {
                    'x': 1046.25,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'top_right': [
        {
            'maxHeight': 800,
            'maxWidth': 843.75,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'right',
            'transformation': {
                'anchor': {
                    'x': 1,
                    'y': 0,
                },
                'position': {
                    'x': 1023.75,
                    'y': 213.33333333333331,
                },
                'rotation': 0,
            },
        },
    ],
    'center': [
        {
            'maxHeight': 888.8888888888888,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0.5,
                },
                'position': {
                    'x': 540,
                    'y': 960,
                },
                'rotation': 0,
            },
        },
    ],
    'bottom_left': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'left',
            'transformation': {
                'anchor': {
                    'x': 0,
                    'y': 1,
                },
                'position': {
                    'x': 67.5,
                    'y': 1706.6666666666665,
                },
                'rotation': 0,
            },
        },
    ],
    'top_center': [
        {
            'maxHeight': 800,
            'maxWidth': 871.875,
            'objectAnimation': [],
            'alphaGraphics': [],
            'name': 'text_1',
            'colorGraphics': [],
            'classType': 'GraphicStyleTextAsset',
            'textAlign': 'center',
            'transformation': {
                'anchor': {
                    'x': 0.5,
                    'y': 0,
                },
                'position': {
                    'x': 540,
                    'y': 213.33333333333331,
                },
                'rotation': 0,
            },
        },
    ],
};
